import {z} from 'zod'

const PushStepSchema = z.object({
  subject: z.string().max(140),
  message: z.string().max(1000),
  selectedPage: z
    .object({
      id: z.string(),
      value: z.string(),
      title: z.string().nullish(),
    })
    .nullish(),
  selectedImage: z
    .object({
      id: z.string(),
      url: z.string(),
      title: z.string().nullish(),
    })
    .nullish(),
})

export type PushStepType = z.infer<typeof PushStepSchema>

const SmsStepSchema = z.object({
  message: z.string().max(140),
})
export type SmsStepType = z.infer<typeof SmsStepSchema>

const WhatsAppStepSchema = z.object({
  selectedTemplateId: z.string().nullish(),
  whatsAppMessage: z.string(),
})

export type WhatsAppStepType = z.infer<typeof WhatsAppStepSchema>

const EmailCustomStepSchema = z.object({
  mode: z.literal('custom'),
  emailSubject: z.string().max(140),
  emailMessage: z.string().max(140),
  selectedPage: z
    .object({
      id: z.string(),
      value: z.string(),
      title: z.string().nullish(),
    })
    .nullish(),
  selectedImage: z
    .object({
      id: z.string(),
      url: z.string(),
      title: z.string().nullish(),
    })
    .nullish(),
})

export type EmailCustomStepType = z.infer<typeof EmailCustomStepSchema>

const EmailTemplateStepSchema = z.object({
  mode: z.literal('template'),
  emailSubject: z.string().max(140),
  selectedTemplateId: z.string().nullish(),
  name: z.string().nullish(),
  html: z.string().nullish(),
})

export type EmailTemplateStepType = z.infer<typeof EmailTemplateStepSchema>

export const EmailStepSchema = z.discriminatedUnion('mode', [EmailCustomStepSchema, EmailTemplateStepSchema])

export type EmailStepType = EmailCustomStepType | EmailTemplateStepType

export function isEmailCustomStep(step: EmailStepType): step is EmailCustomStepType {
  return step.mode === 'custom'
}

export function isEmailTemplateStep(step: EmailStepType): step is EmailTemplateStepType {
  return step.mode === 'template'
}
